import { CommonModule } from '@angular/common';
import { Component, ViewContainerRef } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { AuxiliaryDataFieldSchemaInterface, AuxiliaryDataSearchDateOperation } from '@vendasta/account-group';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { AuxiliaryDataSearchInfoInterface, FilterHandler } from '../auxiliary-data-accounts-table-filters.service';
import { DateRange } from '@vendasta/galaxy/utility/date-utils';

export class DatetFilterHandler implements FilterHandler {
  formControl: FormControl;
  schema: AuxiliaryDataFieldSchemaInterface;
  formControlEndDate: FormControl;

  constructor(public fieldSchema: AuxiliaryDataFieldSchemaInterface) {
    this.formControl = new FormControl();
    this.formControlEndDate = new FormControl();
    this.formControl.setValidators([]);
    this.schema = fieldSchema;
  }

  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    const component = viewContainerRef.createComponent<DateRangeFilterRendererComponent>(
      DateRangeFilterRendererComponent,
    );
    component.instance.controlStart = this.formControl;
    component.instance.controlEnd = this.formControlEndDate;
  }

  filterOperation(operation: AuxiliaryDataSearchDateOperation): AuxiliaryDataSearchInfoInterface {
    return {
      filter: {
        fieldId: this.schema?.fieldId,
        filterRange: {
          beginRange: this.formControl?.value?.toISOString() || '',
          endRange: this.formControlEndDate?.value?.toISOString() || '',
        },
        operation: {
          dateOperation: operation,
        },
      },
      fieldName: this.schema?.fieldName,
      filterValue:
        'from ' + this.formControl?.value?.toISOString() + ' to ' + this.formControlEndDate?.value?.toISOString(),
      operationName: '',
    };
  }
  hasModification(): boolean {
    return this.formControl.dirty;
  }
}

@Component({
  styles: [
    ':host, mat-form-field, input {width:100%}',
    ':host #date {margin: 0 5px; padding: 6px 0 8px;}',
    ':host #date ::ng-deep .input-and-hints {margin:0;}',
  ],
  template: `
    <glxy-form-field size="default">
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [formControl]="controlStart" />
        <input matEndDate placeholder="End date" [formControl]="controlEnd" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </glxy-form-field>
  `,
  imports: [CommonModule, ReactiveFormsModule, MatDatepickerModule, TranslateModule, GalaxyFormFieldModule],
})
export class DateRangeFilterRendererComponent {
  controlStart!: FormControl;
  controlEnd!: FormControl;
  selectedDateRange: DateRange;
}
